import Auth from './api/auth';
import Documents from './api/documents'
import Common from './api/common'
import Users from './api/users'
import axios from './axios';

const token = localStorage.getItem('token');

if (token) {
    axios.addToken(token);
}

function addToken(token) {
    axios.addToken(token);
}

export default {
    auth: Auth(axios),
    documents: Documents(axios),
    common: Common(axios),
    users: Users(axios),
    addToken: (token) => addToken(token)
};
